import { cn } from '@/lib/utils';

export function LogoMark({ className }: { className?: string }) {
  return (
    <img
      src="/favicon.svg?v=callsync-2"
      width={28}
      height={28}
      className={cn('callsync-brand-mark size-7 shrink-0', className)}
      alt=""
      aria-hidden="true"
      draggable={false}
    />
  );
}

export function Logo({ className, showText = true }: { className?: string; showText?: boolean }) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <LogoMark />
      {showText && <span className="text-subheading font-semibold tracking-tight text-fg">CallSync</span>}
    </span>
  );
}

export function FullScreenLoader({ label = 'Loading' }: { label?: string }) {
  return (
    <div
      className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-background"
      role="status"
      aria-live="polite"
    >
      <div className="loading-shimmer relative rounded-2xl p-3">
        <LogoMark className="size-10 rounded-xl" />
        <span className="absolute inset-0 rounded-2xl bg-primary/5" aria-hidden />
      </div>
      <p className="text-sm text-fg-muted">{label}…</p>
    </div>
  );
}
